import React from 'react'
import helpers from 'core/helpers'
import { uniqid } from 'core/utils'
import { ModalProps, ModalState } from './modal.types'

const root: HTMLElement | null = document.getElementById('root')

class ModalMethods extends React.Component<ModalProps, ModalState> {
    state: ModalState = {
        open: false,
    }
    id = uniqid()
    element = document.createElement('div')

    componentDidMount() {
        document.addEventListener('keydown', this.closeByKey)
        if (root) {
            root.appendChild(this.element)
        }
    }

    componentWillUnmount() {
        document.removeEventListener('keydown', this.closeByKey)

        if (root) {
            root.removeChild(this.element)
        }
        helpers.disableWindowScroll(false, this.id)
    }

    shouldComponentUpdate(nextProps: ModalProps) {
        const s_ = this.state

        if (nextProps.open !== s_.open) {
            helpers.disableWindowScroll(nextProps.open, this.id)
            this.setState({ open: nextProps.open })
        }

        return true
    }

    closeByKey = (event: KeyboardEvent) => {
        event = event || window.event

        if (event.keyCode === 27) {
            const p_ = this.props
            if (p_.open && p_.onClose) {
                event.preventDefault()
                p_.onClose()
            }
        }
    }
}

export default ModalMethods
